// Last-write-wins guard for async loaders. Each load() takes a generation via begin(); its response
// is only applied if isCurrent(gen) still holds — i.e. no newer load has started since. This stops a
// slower, older-filter/period response from clobbering a newer one when awaited requests resolve out of
// order (the AbortController pattern in useAllDocuments, minus the request cancellation). Hold the
// instance in a useRef so it persists across renders.
export interface LoadGuard {
  /** Start a new load; returns its generation. Any prior generation is now superseded. */
  begin(): number
  /** True only for the most recently begun generation. */
  isCurrent(gen: number): boolean
}

export function createLoadGuard(): LoadGuard {
  let latest = 0
  return {
    begin: () => ++latest,
    isCurrent: (gen: number) => gen === latest,
  }
}
